// In-memory reverse-geocode cache, scoped to the page lifetime.
//
// Resolved street addresses are location PHI and intentionally NOT
// persisted to localStorage — they shouldn't survive a window close or
// be exposed to same-origin XSS via persistent storage. The cache is
// cleared on full page reload.
//
// Keyed by rounded `lat,lng` (5 decimals).

const cache = new Map<string, string>();

export const getCachedAddress = (key: string): string | undefined =>
    cache.get(key);

export const setCachedAddress = (key: string, value: string): void => {
    cache.set(key, value);
};

// Test-only handle. Allows test suites to prime / clear entries without
// importing the underlying Map. Resolved addresses are location PHI, so
// the handle must not be reachable from the production bundle (an XSS
// payload could otherwise read the cache via window.* module imports).
export const __reverseGeocodeCacheForTests =
    process.env.NODE_ENV === 'test' ? cache : undefined;
